import React from 'react';

export const SwitchVersionIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M5.33333 2L2.66666 4.66667L5.33333 7.33333" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M2.66666 4.66669H13.3333" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M10.6667 14L13.3333 11.3334L10.6667 8.66669" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M13.3333 11.3333H2.66666" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);